Helpful = window.Helpful || {};

Helpful.init = function(options) {
	var $body = $('body');

	$('div.helpful #fieldset_noFieldset input[type=radio]').each(function() {
		$(this).parent().before(this);
	});

	$('#helpful-1').click(function(e) {
		if (typeof options.recaptcha !== 'undefined') {
			Helpful.helpfulPostWithRecaptchaV3(options.recaptcha);
		}
		else {
			Helpful.helpfulPost(options);
		}
		$('#fieldset_noFieldset').hide();
	});
	$('#helpfulBtn').click(function(e) {
		e.preventDefault();
		e.stopPropagation();

		if (!$body.hasClass('helpful-open')) {
			$('#fieldset_noFieldset').slideDown();
			$(this).addClass('selected');
			$body.addClass('helpful-open');
			$('#helpful').val('0');

			if ($body.width() > 992-15) {
				var scrollPosition = $(window).scrollTop() + 287;
				$("html, body").animate({scrollTop: scrollPosition}, 600);
			}
		}
		else {
			$('#fieldset_noFieldset').slideUp();
			$('#helpfulBtn').removeClass('selected');
			Helpful.helpfulReset();
		}

	});
	$('#helpful_submit').click(function(e) {
		if (typeof options.recaptcha !== 'undefined') {
			Helpful.helpfulPostWithRecaptchaV3(options.recaptcha);
		}
		else {
			Helpful.helpfulPost(options);
		}
	});
	$('#helpful_cancel').click(function(e) {
		$('#fieldset_noFieldset').slideUp();
		$('#helpfulBtn').removeClass('selected');
		Helpful.helpfulReset();
	});
	$('div.helpful').on('click', function(e) {
		e.stopPropagation();
	});
	$body.on('click', function (e) {
		if ($body.is('.helpful-open')) {
			$('#fieldset_noFieldset').slideUp();
			$('#helpfulBtn').removeClass('selected')
			Helpful.helpfulReset();
		}
	});
	$('#fieldset_noFieldset #elm_reason .radio').click(function() {
		$('#fieldset_noFieldset #extra').focus();
		$('#fieldset_noFieldset #elm_extra label').text(options.language.explain);
	});

	$('#helpful-success').append($('#helpful-success').data('text'));
};

Helpful.helpfulPost = function() {
	$.post('/_/' + moya.division + '/helpful/index/index', $('#helpful_form').serialize(), function (result) {
		if(!result.success) {
			if(result.message) {
				var errorHtml = '<ul class="errors"><li>' + result.message.message + '</li></ul>';
				var field = result.message.field !== 0 ? result.message.field : 'reason';
				$('#elm_' + field).append(errorHtml);
			}
		}
		else {
			$('#helpful-success').fadeIn();
			$('#helpful_form').toggleClass('hide');
			$('#center .helpful').addClass('success');
			Helpful.helpfulReset();
		}
	}, 'json');
};

Helpful.helpfulPostWithRecaptchaV3 = function(options) {
	if (typeof grecaptcha !== "undefined") {
		var formKey = options.formKey;
		var category = options.category;
		var $form = $('.' + formKey);
		if ($form.data('submitted') !== true) {
			// Ignore duplicates
			$form.data('submitted', true);
			grecaptcha.ready(function() {
				grecaptcha.execute(options.siteKey, {action: category}).then(function(token) {
					$form.find('#' + formKey + '_token').val(token);
					$form.find('#' + formKey + '_category').val(category);
					Helpful.helpfulPost();
				});
			});
		}
	}
};

Helpful.helpfulReset = function() {
	$('#helpful-0, #helpful-1').prop('checked', false);
	$('#fieldset_yesFieldset').removeClass('open');
	$('body').removeClass('helpful-open');
};

